<div class="campaign-overview-component flex-column py-4 px-2">
  <div class="d-flex flex-column mx-auto">
    <div class="d-block">
      <div class="d-none d-md-block d-lg-flex">
        <div class="align-items-center d-flex flex-md-wrap page-tab-control w-100">
          <div
            class="align-items-center d-flex flex-lg-nowrap flex-md-wrap justify-content-lg-start justify-content-md-center project-nav-tabs w-100 h-100"
            [style.gap]="'10px'">
            <div class="d-flex justify-content-lg-start justify-content-md-center w-100 h-100">
              <button
                class="tab-item btn pointer h-100 text-center"
                (click)="toggleTab(0)"
                [ngClass]="{ active: isWorkspace }">
                <span>{{ 'workspace_edit_workspacesPermissions' | translate }}</span>
              </button>
              @if (showProjectPermission) {
                <button
                  class="tab-item btn pointer h-100 text-center"
                  (click)="toggleTab(1)"
                  [ngClass]="{ active: isProject }">
                  <span>{{ 'workspace_edit_projectsPermissions' | translate }}</span>
                </button>
              }
            </div>

            <div
              class="align-items-center d-flex justify-content-end justify-content-lg-end justify-content-md-center w-100"
              [style.gap]="'10px'">
              <div class="tab-item p-0" [style.border-bottom]="'none'">
                <button
                  class="btn btn-orange text-uppercase position-relative btn-remove-workspace text-nowrap py-1 px-4"
                  [disabled]="!canDeleteWorkspace"
                  (click)="deleteWorkspace()">
                  <span class="f-10 _700">{{ 'removeWorkspace' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-block d-md-none">
        <div class="d-flex flex-column page-tab-control">
          <div class="d-flex flex-wrap mb-3 project-nav-tabs w-100">
            <button
              class="tab-item btn pointer w-100 text-center"
              (click)="toggleTab(0)"
              [ngClass]="{ active: isWorkspace }">
              <span>{{ 'workspace_edit_workspacesPermissions' | translate }}</span>
            </button>
            <button
              class="tab-item btn pointer w-100 text-center"
              (click)="toggleTab(1)"
              [ngClass]="{ active: isProject }">
              <span>{{ 'workspace_edit_projectsPermissions' | translate }}</span>
            </button>
          </div>
          <div class="align-items-center d-flex flex-wrap justify-content-center w-100" [style.gap]="'10px'">
            <div class="tab-item p-0 w-100">
              <button
                class="btn btn-orange text-uppercase position-relative btn-remove-workspace text-nowrap py-1 px-4"
                [disabled]="!canDeleteWorkspace"
                (click)="deleteWorkspace()">
                <span class="f-10 _700">{{ 'removeWorkspace' | translate }}</span>
              </button>
            </div>
            <div class="tab-item p-0 w-100">
              <button
                class="btn btn-orange text-uppercase position-relative btn-save-changes text-nowrap py-1 px-4"
                [disabled]="!canUpdateWorkspace"
                (click)="save()">
                <span class="f-10 _700">{{ 'saveChanges' | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="px-2 pb-1">
  @if (tabIndex == 0) {
    @if (ENABLE_NEW_PERMISSION_UI_WORKSPACE) {
      @if (workspace?.id) {
        <mtm-workspace-general-info class="d-block mb-3" [workspace]="workspace" />
      }
      <mtm-account-page [itemUuid]="workspace.id" [entityType]="'WORKSPACE'" />
    } @else {
      <mtm-edit-workspace-permissions
        [workspaceId]="workspace.id"
        [setBreadcrumb]="setBreadcrumb.bind(this)"
        [owner]="workspace?.createdBy">
      </mtm-edit-workspace-permissions>
    }
  } @else {
    <mtm-workspace-projects
      [workspace]="workspace"
      [companyUsers]="companyUsers"
      [setBreadcrumb]="setBreadcrumb.bind(this)">
    </mtm-workspace-projects>
  }
</div>
